export default class Boost {
    constructor({
        BoostReason,
        Clicks,
        ClicksLimit,
        CompletedDate,
        CreationDate,
        IsFree,
        RejectionReasonsStandard,
        RejectionReasonsX5,
        Status,
        Tariff,
        UserId
    }) {
        this.boostReason = BoostReason;
        this.clicks = Clicks;
        this.clicksLimit = ClicksLimit;
        this.completedDate = CompletedDate;
        this.creationDate = CreationDate;
        this.isFree = IsFree;
        this.rejectionReasonsStandard = RejectionReasonsStandard;
        this.rejectionReasonsX5 = RejectionReasonsX5;
        this.status = Status;
        this.tariff = Tariff;
        this.userId = UserId;
    }
}
